import { planningAPI } from "../../axios";

export const actions = {
    //KPIAnnualTarget
    GetKPIAnnualTarget(context, data){
        return planningAPI.get(`KPIAnnualTarget/All/${data.campusId}/${data.indicatorItemId}`);
    },
    GetSingleKPIAnnualTarget(){
        return planningAPI.get(`KPIAnnualTarget/GetAllJobCategories`);
    },
    UpdateKPIAnnualTarget(context, data){
        return planningAPI.put(`KPIAnnualTarget/Update/${data.id}`, data);
    },
    DeleteKPIAnnualTarget(context, data){
        return planningAPI.delete(`KPIAnnualTarget/Remove/${data}`);
    },
    CreateKPIAnnualTarget(context, data){
        return planningAPI.post(`KPIAnnualTarget/Add?cycle=${data.cycle}&campusId=${data.campusId}`, data);
    },
}